var yall=function(){"use strict";return function(e){var n=(e=e||{}).lazyClass||"lazy",o=e.lazyBackgroundClass||"lazy-bg",t="idleLoadTimeout"in e?e.idleLoadTimeout:200,r=e.observeChanges||!1,i=e.events||{},a=window,s="requestIdleCallback",c="IntersectionObserver",u=["srcset","src","poster"],d=[],l=function(e,t){return d.slice.call((t||document).querySelectorAll(e||"img."+n+",video."+n+",iframe."+n+",."+o))},f=function(n){var t,r,i=n.parentNode;for(var a in"PICTURE"==i.nodeName&&(r=i),"VIDEO"==n.nodeName&&(r=n),t=l("source",r))b(t[a]);b(n),n.autoplay&&n.load();var s=n.classList;s.contains(o)&&(s.remove(o),s.add(e.lazyBackgroundLoaded||"lazy-bg-loaded"))},v=function(e){for(var n in i)e.addEventListener(n,i[n].listener||i[n],i[n].options||void 0);h.observe(e)},b=function(e){u.forEach(function(n){n in e.dataset&&a.requestAnimationFrame(function(){e[n]=e.dataset[n]})})},g=l();if(/baidu|(?:google|bing|yandex|duckduck)bot/i.test(navigator.userAgent))for(var m in g)f(g[m]);else if(c in a&&c+"Entry"in a){var h=new a[c](function(e,o){e.forEach(function(e){if(e.intersectionRatio){var i=e.target;s in a&&t?a[s](function(){f(i)},{timeout:t}):f(i),i.classList.remove(n),o.unobserve(i),(g=g.filter(function(e){return e!=i})).length||r||h.disconnect()}})},{rootMargin:("threshold"in e?e.threshold:200)+"px 0%"});for(var y in g)v(g[y]);r&&new MutationObserver(function(){l().forEach(function(e){g.indexOf(e)<0&&(g.push(e),v(e))})}).observe(l(e.observeRootSelector||"body")[0],e.mutationObserverOptions||{childList:!0,subtree:!0})}}}();
document.addEventListener("DOMContentLoaded", yall);

window.addEventListener('DOMContentLoaded', (event) => {
  if ( jQuery( ".my-slider" ).length ) {
    var slider = tns({
      container: '.my-slider',
      items: 1,
      slideBy: 1,
      controls: false,
      speed: 1000,
      autoplay:true,
      //autoplayTimeout: 8000,
      //autoplayHoverPause: true,
      autoplayButtonOutput: false,
      loop: true,
      mouseDrag: true,
      slideBy: 'page'
    });
  }
  if ( jQuery( ".cSlides" ).length ) {
    var slider = tns({
      container: '.cSlides',
      items: 1,
      controls: false,
      speed: 400,
      autoplay:true,
      autoplayHoverPause: true,
      autoplayButtonOutput: false,
      loop: true,
      mouseDrag: true,
      mode: 'carousel',
      slideBy: 'page',
      responsive: {
        640: {
          items: 3
        }
      },
      container: '#responsive',
    });
  }
});

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {$} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {$} options.$container - Container to trap focus within
   * @param {$} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {$} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {$} options.$tables - $ object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {$} options.$iframes - $ object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '{{amount}} lei';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    //var formatString = (format || moneyFormat);
    var formatString = moneyFormat;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if ( isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    /*
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
    */
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;
      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
      //console.log(variant);
      if(variant.featured_image !== null){
        vimage = variant.featured_image.src;
        if(vimage != ""){
          jQuery("#ProductPhotoImg").attr("src",vimage);
          imgposition = jQuery('#PThumbs a[data-image-id="'+variant.featured_image.id+'"]').data("gallery-position");
          //console.log("imageposition:"+imgposition+" for vimage:"+variant.featured_image.id);
          jQuery("#ProductPhotoImg").data("gallery-position", imgposition);
        }
      }
      $("#pSKU").html(variant.sku);
    }
  });

  return Variants;
})();


/* Thumbs product */
jQuery( document ).ready(function($) {
  $('#PThumbs').slick({
    slidesToShow: 4,
    infinite: false,
    arrows: true,
    autoplay: true,
    slidesToScroll: 1,
    prevArrow:"<button type='button' class='slick-prev'><i class='i i-arr_l_bold'></i></button>",
    nextArrow:"<button type='button' class='slick-next'><i class='i i-arr_r_bold'></i></button>"
  });
});

/* SLider for imgs upsell product */


jQuery( document ).ready(function($) {
  $('#upsell-popup-adc .single-upsell .paccBImg').slick({
    slidesToShow: 1,
    infinite: true,
    arrows: true,
    slidesToScroll: 1,
    prevArrow:"<button type='button' class='slick-prev pull-left'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'></button>",
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    }]
  });
});


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  var checkMultiATC = function(){
    if( $("#multiAtc").val() == "true"){
      return true;
    }else{
      return false;
    }
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },



    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      totalPrice = variant.price;
      if( checkMultiATC() == true){
        if($("#handlesNr").val() && $("#handlesId").data("price")){
          handlesPrice = $("#handlesNr").val() * $("#handlesId").data("price");
          totalPrice += handlesPrice;
        }
        if($("#feetNr").val() && $("#feetId").data("price")){
          feetPrice = $("#feetNr").val() * $("#feetId").data("price");
          totalPrice += feetPrice;
        }
        if( $("#accent_finishId").data("price") ){
          totalPrice += $("#accent_finishId").data("price");
        }
        if( $("#custom_optionId").data("price") ){
          totalPrice += $("#custom_optionId").data("price");
        }
        if( $("#fabricId").data("price") ){
          totalPrice += $("#fabricId").data("price");
        }
      }
      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(totalPrice, theme.moneyFormat));
      /*
      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
      */
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


window.addEventListener('DOMContentLoaded', function () {


  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

window.addEventListener('DOMContentLoaded', function () {


  // show/hide menu
  document.getElementById("topMenuBar").onclick = function(e){
    document.getElementById("topMenuBar").classList.toggle("active");
    document.getElementById("top_menu").classList.toggle("active");
    document.getElementById("shopify-section-header").classList.toggle("active");
  }

  document.getElementById("close-sm").onclick = function(e){
    document.getElementById("topMenuBar").classList.toggle("active");
    document.getElementById("top_menu").classList.toggle("active");
    document.getElementById("shopify-section-header").classList.toggle("active");
  }
  //cart page and slide cart
  $("#PCartProds, #CartPProds").on('click', '.PcartRemove' ,function(){
      cartLineID = $(this).closest(".cartLC").data("id");
      data = 'updates['+cartLineID+']=0';
      $("#PCartProds .cartLine[data-main-product-id='"+cartLineID+"']").each(function( index ) {
        line_id = $(this).data("id");
        data += "&updates["+line_id+"]=0";
      });
      $.ajax({
          type: "POST",
          url: '/cart/update.js',
          data: data,
          dataType: "json",
          success: function(rdata){
              $(".cartLine"+cartLineID).fadeOut(300, function(){ $(this).remove();});
              price  = rdata.total_price;
              nrcart = 0;
              for (var i = 0; i < rdata.items.length; i++) {
                _hide = "";
                var child = rdata.items[i];
                if( typeof child.properties._hide != "undefined"){

                }else{
                  nrcart++;
                }
              }
              //rdata.item_count;
              $("#PCartQty, #tCartNr, #CartPQty").html(nrcart);
              $("#PCartTotal, #PCartTotal2, #CartPTotal, #CartPTotal2").html( slate.Currency.formatMoney(rdata.total_price, theme.moneyFormat) );
          }
      });
  });
  $( ".SMenuIW li" ).mouseover(function() {
    $(this).parent().children("li").removeClass("active");
    $(this).addClass("active");
  });
  $("#PCartClose, .closeCart").click(function(){
      $(".hPCart").hide();
  });
  $(".tCart a").click(function(e){
      e.preventDefault();
      $(".hPCart").show();
  });
	$(".tMainMenu > .hasSM > a").click(function(e){
		device = document.body.dataset.device;
		if(device == "mobile" || device == "tablet" || jQuery(window).width() < 1024){
			e.preventDefault();
			$(this).toggleClass("active");
			$(this).parent().find(".tSMenu").toggleClass("active");
		}
  });
  $(".SMenuIW .hasSM > a").click(function(e){
      e.preventDefault();
      $(this).parent().toggleClass("show");
      elem = $(this);
    	elem[0].scrollIntoView({behavior: "smooth", block: "start"});
  });
  $("#searchSmOpen").click(function(e){
    $(this).toggleClass("active");
    $(".tSF").toggleClass("active");
  });

  // SET HEADER COOKIE
  function setCookie(cname,cvalue,exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires=" + d.toGMTString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      //alert(cname + "=" + cvalue + ";" + expires + ";path=/");
  }
  function getCookie(cname) {
      //cname = cname.replace(/-/g, ' ');
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }
  function getTimeRemaining(endtime) {
      //alert(endtime);
      var t = Date.parse(endtime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
      var days = Math.floor(t / (1000 * 60 * 60 * 24));

      return {
          'total': t,
          'days': days,
          'hours': hours,
          'minutes': minutes,
          'seconds': seconds
      };
  }
  function initializeClock(id, endtime) {
      //alert(id + " " +endtime);
      var clock = document.getElementById(id);
      var daysSpan = clock.querySelector('.days');
      var hoursSpan = clock.querySelector('.hours');
      var minutesSpan = clock.querySelector('.minutes');
      var secondsSpan = clock.querySelector('.seconds');
      function updateClock() {
          var t = getTimeRemaining(endtime);
          daysSpan.innerHTML = t.days;
          hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
          minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
          secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
          if (t.total <= 0) {
              clearInterval(timeinterval);
          }
      }
      updateClock();
      var timeinterval = setInterval(updateClock, 1000);
  }
  function tOC(){
    //var DAYS = parseInt($("#clockdiv").data("days"));
    var DAYS = parseInt(document.getElementById('clockdiv').dataset.days);
    var HOURS = parseInt(document.getElementById('clockdiv').dataset.hours);
    var MINUTES = parseInt(document.getElementById('clockdiv').dataset.minutes);
    var SECONDS = parseInt(document.getElementById('clockdiv').dataset.seconds);
    var MILLISECONDS = parseInt(document.getElementById('clockdiv').dataset.milliseconds);
    countdownCookie = getCookie("countdowndate");
    if(countdownCookie != ""){
        deadline = getCookie("countdowndate");
        deadline = deadline.replace(/-/g, ' ');
        //alert("FOUND THE COOKIE "+deadline);
    }else{
        //alert("No cookie");
        var d = new Date();
        //BLACK FRIDAY
        //var d = new Date("November 29, 2018 00:00:00");
        var newdate = Date.parse(d);
        cvalue = new Date(newdate + DAYS * HOURS * MINUTES * SECONDS * MILLISECONDS);
        //cvalue = new Date(newdate);
        d.setTime(d.getTime() + (DAYS * HOURS * MINUTES * SECONDS * MILLISECONDS));
        //d.setTime(d.getTime());
        var expires = "expires="+ d.toUTCString();
        var ctime = d.toUTCString().replace(/ /g,"-");
        //document.cookie = "countdowndate=" + cvalue + ";" + expires + ";path=/";
        document.cookie = "countdowndate="+ctime+";"+expires+";path=/";
        deadline = getCookie("countdowndate");
        deadline = deadline.replace(/-/g, ' ');
        //alert("deadline is not set:"+deadline);
    }
    initializeClock('clockdiv', deadline);
  }
	var element =  document.getElementById('tb1');
	if(typeof(element) != 'undefined' && element != null){
		tOC();
	}
  //SEARCH 

function searchMenu(){
  let currentAjaxRequest = null,
      input = $("#Search");

  input.attr('autocomplete', 'off').bind('keyup change', function() {
      let term = $(this).val(),
          searchURL = '/search?type=product&q=*' + term + '*',
          resultsList = $('.search-results');
      if (term.length > 3 && term !== $(this).attr('data-old-term')) {
          resultsList.empty();
          $(this).attr('data-old-term', term);
          if (currentAjaxRequest !== null) currentAjaxRequest.abort();
          currentAjaxRequest = $.getJSON("/search/suggest.json", {
              s: term,
              resources: {
                  "types": ["product"],
                  "limit": 8,
                  "unavailable_products": "bury"
              }}
          ).done(function(data) {
            
              let products = data.resources.results.products;
              if (products === 0) {
                  resultsList.html('<p>Nu s-au găsit produse.</p>');
                  resultsList.fadeIn(200);
                  resultsList.hide();
              } else {
                console.log(products);
                  partsHTML = "";
                  productsHTML = "";
                  $.each(products, function(index, item) {
                    if(item.tags.indexOf("hidden") == -1){
                    	if(item.tags.indexOf("parts") != -1){
                        	//console.log(item.title+" contains parts");
                            partsHTML += "<div class='searchResult' ><div class='gX gMX aM'><div class='s3 m2 l2 c'><a href='"+item.url+"'><img src='"+item.image+"' /></a></div><div class='s9 m10 l10 c'><a href='"+item.url+"'><p class='title'>" + item.title + "</p><p class='price'>De la "+item.price_min+" lei</p></a></div></div></div>";
                        }else{
                            productsHTML += "<div class='searchResult'><div class='gX gMX aM'><div class='s3 m2 l2 c'><a href='"+item.url+"'><img src='"+item.image+"' /></a></div><div class='s9 m10 l10 c'><a href='"+item.url+"'><p class='title'>" + item.title + "</p><p class='price'>De la "+item.price_min+" lei</p></a></div></div></div>";
                        }
                    }
                  });
                  if(productsHTML != ""){
          				resultsList.append(productsHTML);
                    	resultsList.fadeIn(200);
                  }else if(partsHTML != ""){
                      	resultsList.append(partsHTML);
                    	resultsList.fadeIn(200);
                  }else{
                    resultsList.hide();	
                    //resultsList.append("Ne pare rău, nu am găsit niciun produs care să corespundă căutării dvs.");
                  }
              }
          });
      }
      if (term.length <= 3){
        $(resultsList).hide();
      }
  });
}
searchMenu();

  $("#tSearchM").click(function(){
    var currentAjaxRequest = null;
    $(".tSF.tSMenu").show();
    var input = $("#Search");
    input.attr('autocomplete', 'off').bind('keyup change', function() {
        var term = $(this).val();
        var searchURL = '/search?type=product&q=*' + term + '*';
        var resultsList = $('.search-results');
        if (term.length > 3 && term !== $(this).attr('data-old-term')) {
            resultsList.empty();
            $(this).attr('data-old-term', term);
            if (currentAjaxRequest !== null) currentAjaxRequest.abort();
            currentAjaxRequest = $.getJSON("/search/suggest.json", {
                s: term,
                resources: {
                    "types": ["product"],
                    "limit": 4,
                    "unavailable_products": "bury"
                }}
            ).done(function(data) {
              	console.log(data);
                var products = data.resources.results.products;
                if (products === 0) {
                    resultsList.html('<p>Nu s-au găsit produse.</p>');
                    resultsList.fadeIn(200);
                    resultsList.hide();
                } else {
                  	console.log(products);
                  	partsHTML = "";
                  	productsHTML = "";
                    $.each(products, function(index, item) {
                    	if(item.tags.indexOf("parts") != -1){
                      		console.log(item.title+" contains parts");
                          	partsHTML += "<div class='searchResult'><div class='gX gMX aM'><div class='s3 m2 l2 c'><a href='"+item.url+"'><img src='"+item.image+"' /></a></div><div class='s9 m10 l10 c'><a href='"+item.url+"'><p class='title'>" + item.title + "</p><p class='price'>De la "+item.price_min+" lei</p></a></div></div></div>";
                        }else{
                          	productsHTML += "<div class='searchResult'><div class='gX gMX aM'><div class='s3 m2 l2 c'><a href='"+item.url+"'><img src='"+item.image+"' /></a></div><div class='s9 m10 l10 c'><a href='"+item.url+"'><p class='title'>" + item.title + "</p><p class='price'>De la "+item.price_min+" lei</p></a></div></div></div>";
                        }
                    });
                    if(productsHTML != ""){
						resultsList.append(productsHTML);
                    }else if(partsHTML != ""){
                      	resultsList.append(partsHTML);
                    }else{
                    	resultsList.append("Ne pare rău, nu am găsit niciun produs care să corespundă căutării dvs.");
                    }
                    resultsList.fadeIn(200);
                }
            });
        }
    });
    $("#closeSearch").click(function(){
        $("form.tSF").hide();
    });
  });
  $(".popupClose").click(function(){
    $(this).closest(".hPopup").hide();
  });
  $(".hPQty > div").click(function(){
    var value = parseInt( $("#Quantity").val() );
    c = $(this).data("do");
    value = isNaN(value) ? 1 : value;
    if(c=="-" ){
      if(value > 1) value--;
    }else{
      value++;
    }      
    document.getElementById('Quantity').value = value;
  });
  $(".PTabTitle").click(function(){
    ct = $(this).parent();
    $(".hPTab").each(function(){
      if($(this).data("id") != ct.data("id") ){
      	$(this).removeClass("active");
      }
    });
   	ct.toggleClass("active");
  })
  //VARIATION FINISH
  $('#finishPopup .var_opt').on("click", "a", function(e){
    e.preventDefault();
    selv = $(this).data("sel");
    $(this).parent().closest("ul").children().removeClass("active");
    $(this).parent().addClass("active");
    $("#"+$(this).parent().closest("ul").data("id")).val(selv).trigger('change');
    $("#finishSImg").attr('src', $(this).children('img').data('src') );
    $("#finishSTxt").html( $(this).children('span').html() );
    $(this).closest(".hPopup").hide();
  });
  $("#finishPop").click(function(){
      $(this).closest(".hPOption").toggleClass("active");
      $("#finishPopup").show();
      yall({
          observeChanges: false,
          lazyClass: 'finishImg'
      });
  });
  $("#finishPopup .popupBg").click(function(){
    $("#finishPopup").hide();
  });
  //VARIATION FABRIC
  $('#fabricPopup .var_opt').on("click", "a", function(e){
    e.preventDefault();
    selv = $(this).data("sel");
    $(this).parent().closest("ul").children().removeClass("active");
    $(this).parent().addClass("active");
    $("#"+$(this).parent().closest("ul").data("id")).val(selv).trigger('change');
    $("#fabricSImg").attr('src', $(this).children('img').data('src') );
    $("#fabricSTxt").html( $(this).children('span').html() );
    $(this).closest(".hPopup").hide();
    $('body').removeClass('popupActive');
  });
  $("#fabricPop").click(function(){
      $(this).closest(".hPOption").toggleClass("active");
      $("#fabricPopup").show();
		$('body').addClass('popupActive');
      yall({
          observeChanges: false,
          lazyClass: 'fabricImg'
      });
  });
  $("#fabricPop .popupBg").click(function(){
    $("#fabricPop").hide();
    $('body').removeClass('popupActive');
  });
  //VARIATION FEET
  $('#feetPopup .var_opt').on("click", "a", function(e){
    e.preventDefault();
    selv = $(this).data("sel");
    $(this).parent().closest("ul").children().removeClass("active");
    $(this).parent().addClass("active");
    $("#"+$(this).parent().closest("ul").data("id")).val(selv).trigger('change');
    $("#feetSImg").attr('src', $(this).children('img').data('src') );
    $("#feetSTxt").html( $(this).children('span').html() );
    $(this).closest(".hPopup").hide();
  });
  $("#feetPop").click(function(){
      $(this).closest(".hPOption").toggleClass("active");
      $("#feetPopup").show();
      yall({
          observeChanges: false,
          lazyClass: 'feetSImg'
      });
  });
  $("#feetPop .popupBg").click(function(){
    $("#feetPop").hide();
  });
  $("#finishOptPopup .popupBg").click(function(){
    $("#finishOptPopup").hide();
  });
  $("#accent_finishPopup .popupBg").click(function(){
    $("#accent_finishPopup").hide();
  });
  $("#custom_optionPopup .popupBg").click(function(){
    $("#custom_optionPopup").hide();
  });
  $("#handlesPopup .popupBg").click(function(){
    $("#handlesPopup").hide();
    $('body').removeClass('popupActive');
  });
  
  //FAQ
  $(".FAQtitle").click(function(){
      $(this).parent().toggleClass("active");
  })
  //INSTAGRAM
  function instaFeed(){
      var token = '2304777884.1677ed0.e482e36c00de4f9194709453657cde97',
          num_photos = 20, // maximum 20
          container = document.getElementById( 'instafeed' ), 
          scrElement = document.createElement( 'script' );
      
      window.instaProcessResult = function( data ) {
          console.log(data);
          i = 0;
          for( x in data.data ){
              if(i < 4){
                  if( data.data[x].images.standard_resolution.height == data.data[x].images.standard_resolution.width){
                      container.innerHTML += '<div class="c s12 m3 l3"><a href="#" class="instaPic"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAkcAAAGFAQMAAADNRcWWAAAAA1BMVEX///+nxBvIAAAAM0lEQVR42u3BMQEAAADCIPuntsYOYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEDQAXByAAE2Y+kzAAAAAElFTkSuQmCC" data-src="' + data.data[x].images.standard_resolution.url + '" alt="" width="640" height="640" class="instaImg"><p class="instaBtn"><span class="instaBtnW"><span><i class="i i-ig"></i></span><span class="wbButton">SHOP NOW &nbsp;&nbsp;&nbsp;<i class="i i-arr_r_bold"></i></span></span></p></a></div>';
                      i++;
                  }
              }		
          }
          yall({
              observeChanges: false,
              lazyClass: 'instaImg'
          });

      }
      scrElement.setAttribute( 'src', 'https://api.instagram.com/v1/users/self/media/recent?access_token=' + token + '&count=' + num_photos + '&callback=instaProcessResult' );
      instascript = document.getElementById( 'instaScript' );
	    if(instascript){
        instascript.appendChild( scrElement );
      }
  }
  //instaFeed();
  
  jQuery(".footHeadM").click(function(){
    id = jQuery(this).data("id");
    jQuery(this).parent().toggleClass('active');
  });

  //COOKIE POLICY
  setTimeout(function(){
    
    cookiePolicy = getCookie("acceptcookies");
    if(cookiePolicy != ""){
        //dont show
    }else{
        document.getElementById('hCookiePanel').classList.add("active");
    }
    document.getElementById('cookiesContinue').onclick = function(e){
        e.preventDefault();
        setCookie("acceptcookies", "yes", 90);
        document.getElementById('hCookiePanel').classList.remove("active");
    }
    document.getElementById('cookiesClose').onclick = function(e){
        e.preventDefault();
        setCookie("acceptcookies", "yes", 90);
        document.getElementById('hCookiePanel').classList.remove("active");
    }
  }, 3000);

  function getParameter(theParameter) {
		var params = window.location.search.substr(1).split('&');
		for (var i = 0; i < params.length; i++) {
            var p=params[i].split('=');
            if (p[0] == theParameter) {
                return decodeURIComponent(p[1]);
            }
		}
		return null;
  }
  if(getParameter("location") != null){
    if( getParameter("location")== "RO"){
      	setCookie("geolocation", "Romania", 90);
    }
  }
  //GEO REDIRECT
  admin_url = window.location.host;
  geolocation = getCookie("geolocation");
  if(geolocation == "Romania" || admin_url == "rominaromania.myshopify.com"){
      //dont show
  }else{
      jQuery.ajax({
          //30a9ec1029213be5f46deefb08a02bfd
          url: '//api.ipstack.com/check?access_key=1afe859c97bc56bb657c1513d5e0cc68',
          type: 'POST',
          dataType: 'json',
          success: function (location) {
              if( location.country_name == "Romania"){
                  setCookie("geolocation", "Romania", 90);
              }else if( location.country_name == "United States" || location.country_name == "Canada" ){
                window.location = "https://rominafurniture.com";
              }else{
                //window.location = "https://rominafurniture.eu";
                /*jQuery("#geoUS").click(function(e){
                    e.preventDefault();
                    setCookie("geolocation", "United States", 90);
                    jQuery("#geolocation").hide();
                });
                jQuery("#geolocation").show();
                yall({
                    observeChanges: false,
                    lazyClass: 'geoImg'
                });
                */
              }
          }
      });    
  }
  Shopify.AjaxifyCart = (function($) {
    
    var _config = {
        
        // What you might want to change
        addToCartBtnLabel:             'Adauga in cos',
        addedToCartBtnLabel:           'Multumim!',
        addingToCartBtnLabel:          'Se adauga...',
        soldOutBtnLabel:               'Nu este in stoc',
        howLongTillBtnReturnsToNormal: 1000, // in milliseconds.
        cartCountSelector:             '.cart-count, #cart-count a:first, #gocart p a, #cart .checkout em, .item-count',
        cartTotalSelector:             '#cart-price',

        
        // What you will never need to change
        addToCartBtnSelector:          '[type="submit"]',
        addToCartFormSelector:         'form[action="/cart/add"]',
        shopifyAjaxAddURL:             '/cart/add.js',
        shopifyAjaxCartURL:            '/cart.js'
    };
    
    // We need some feedback when adding an item to the cart.
    var _showFeedback = function(success, html, $addToCartForm) {
        jQuery('.ajaxified-cart-feedback').remove();
        var feedback = '<p class="ajaxified-cart-feedback ' + success + '">' + html + '</p>';
        $addToCartForm.find(_config.addToCartBtnSelector).after(feedback);
        jQuery('.ajaxified-cart-feedback').slideDown();
    };
    var _updateCart = function(itemData){
        var $addToCartForm = jQuery("AddToCartForm");
        var $addToCartBtn = jQuery("#AddToCart");
        // Re-enable add to cart button.
        $addToCartBtn.addClass('inverted');
        _setText($addToCartBtn, _config.addedToCartBtnLabel);
        window.setTimeout(function(){
            $addToCartBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
            _setText($addToCartBtn,_config.addToCartBtnLabel);
        }, _config.howLongTillBtnReturnsToNormal);
        // Update cart count and show cart link.
        $.getJSON(_config.shopifyAjaxCartURL, function(cart) {
            cart_nr = 0;
            if (_config.cartCountSelector && jQuery(_config.cartCountSelector).length ) {
                var value = $(_config.cartCountSelector).html() || '0';
                jQuery(_config.cartCountSelector).html(value.replace(/[0-9]+/,cart.item_count)).removeClass('hidden-count');
            }
            if( cart.items.length){
                jQuery("#PCartProds").empty();
                for (var i = 0; i < cart.items.length; i++) {
                    _hide = "";
                    var child = cart.items[i];
                    variantTxt = "";
                    if( child.variant_title != null ){
                        variantTxt = '<p>'+child.variant_title+'</p>';
                    }
                    variantProperties = "";
                    _mainProduct = "";
                  	cart_line_price = child.final_line_price;
                    if( child.properties != null ){
                      if( typeof child.properties.Handles != "undefined"){
                        variantProperties += "<p>Butoni/Manere: " + child.properties.Handles + "</p>";
                        cart_line_price = cart_line_price + parseInt(child.properties._HandlesPrice);
                      }
                      if( typeof child.properties.AccentFinish != "undefined"){
                        variantProperties += "<p>Finisaj Accent: " + child.properties.AccentFinish + "</p>";
                        cart_line_price = cart_line_price + parseInt(child.properties._AccentFinishPrice);
                      }
                      if( typeof child.properties.CustomOption != "undefined"){
                        variantProperties += "<p>Optiune Pers.: " + child.properties.CustomOption + "</p>";
                      }
                      if( typeof child.properties.Fabric != "undefined"){
                        variantProperties += "<p>Material: " + child.properties.Fabric + "</p>";
                      }
                      if( typeof child.properties.Feet != "undefined"){
                        variantProperties += "<p>Picioare: " + child.properties.Feet + "</p>";
                      }
                      if( typeof child.properties.For != "undefined"){
                        variantProperties += "<p>Pentru: " + child.properties.For + "</p>";
                      }
                      if( typeof child.properties._mainProduct != "undefined"){
                        _mainProduct = child.properties._mainProduct;
                      }
                      if( typeof child.properties._hide === "undefined"){
                        cart_nr++;
                      }else{
                        _hide = "display:none;";
                      }
                    }else{
                      cart_nr++;
                    }
                  	console.log(cart_line_price);
                  	cart_line_price = slate.Currency.formatMoney(cart_line_price, theme.moneyFormat);
                    jQuery("#PCartProds").append('<div class="gX cartLine cartLine'+child.id+'" style="'+_hide+'" data-main-product-id="'+_mainProduct+'" data-id="'+child.id+'"><div class="s3 c"><img src="'+child.image+'" alt="'+child.product_title+'"></div><div class="s9 c"><div class="cartLC" data-id="'+child.id+'"><a href="/products/'+child.handle+'"><h5>'+child.product_title+'</h5></a>'+variantTxt+variantProperties+'<div class="cartLCqty">Cantitate: '+child.quantity+'</div><span class="PcartRemove"><i class="i i-trash"></i></span><div class="cartLCprice">'+cart_line_price+'</div></div></div></div>');
                }
            }
            jQuery("#tCartNr, #PCartQty").html(cart_nr);
            jQuery("#PCartTotal, #PCartTotal2").html( slate.Currency.formatMoney(cart.total_price, theme.moneyFormat) );
            if($("#upsell-products").length){
              jQuery("#upsell-popup-adc").show();
              jQuery('#upsell-popup-adc .paccBImg ').slick('setPosition');
            }else if($("#mattresses-upsell").length){
            	jQuery("#mattresses-upsell").show();
            }else{
              jQuery(".hPCart").show();
            }
          
        }); 
    };

    jQuery('.close-btnUP').click(function(){
      jQuery("#mattresses-upsell").hide();
    });
    
    /* Custom js for popup upsell start */
    jQuery('.close-btnUP').click(function(){
      jQuery("#upsell-popup-adc").hide();
      jQuery(".hPCart").show();      
    });
    
    jQuery("#upsell-popup-adc .single-upsell .accOpt").change(function(){
      var id = jQuery(this).parent('.paccVars').parent('.right').parent('.single-upsell').attr("id");
      var currentOptions = $.map($("#"+id+" .accOpt"), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};
        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          return currentOption;
        }
      });   
      copt = compact(currentOptions);
      svar = "";
      i = 0;
      copt.forEach(function(popt) {
        if(i > 0){
          svar += " / "+popt.value;
        }else{
          svar = popt.value
        }
        i++;
      });
      
      var options = $("#"+id + " .accVarSel option");
      var sopt = $.map(options ,function(option) {
        if(svar == option.text){
          return option.value;
        }            
      });
      $("#"+id + " .accVarSel").val(sopt).prop('selected', true);           
  });
  jQuery("#upsell-popup-adc .single-upsell .atc").click(function(e){
    e.preventDefault();
    id = jQuery(this).parent('.right').parent('.single-upsell').attr("id");
    button = jQuery(this);
    button.html("Please wait");
    button.prop('disabled', true);
    pid = $("#"+id + " .accVarSel").val();
    shopifyAjaxAddURL   = '/cart/add.js';
    parray = [];
    parray.push({
      variantId: pid,
      qty: 1
    });
    moveAlong = function() {
      if (parray.length) {
        var request = parray.shift();
        var data = 'id='+ request.variantId + '&quantity='+request.qty;
        // Add to cart.
        jQuery.ajax({
          url: shopifyAjaxAddURL,
          dataType: 'json',
          type: 'post',
          data: data,
          success: function(itemData) {
            moveAlong();
          }, 
          error: function(XMLHttpRequest) {
            alert("error");
          }
        });
      }else{
        _updateCart();
      }
    };
    moveAlong();
    button.html("Adauga in Cos");
    button.prop('disabled', false);
    jQuery(".hPCart").show();
  });
    
    /* Custom js for popup upsell end */

    jQuery(".ProdAcc .button").click(function(){
      id = jQuery(this).data("id");
      jQuery("#prodUP"+id).show();
      jQuery("#prodUP"+ id +" .accOpt").change(function(){
          var currentOptions = $.map($(".accOpt", "#prodUP"+id), function(element) {
              var $element = $(element);
              var type = $element.attr('type');
            
              var currentOption = {};
              if (type === 'radio' || type === 'checkbox') {
                  if ($element[0].checked) {
                      currentOption.value = $element.val();
                      currentOption.index = $element.data('index');

                      return currentOption;
                  } else {
                      return false;
                  }
              } else {
                  currentOption.value = $element.val();
                  currentOption.index = $element.data('index');
                  return currentOption;
              }
          });
            console.log(currentOptions);

          copt = compact(currentOptions);
          svar = "";
          i = 0;
          copt.forEach(function(popt) {
              if(i > 0){
                  svar += " / "+popt.value;
              }else{
                  svar = popt.value
              }
              i++;
          });
          var options = $("#prodUP"+id + " .accVarSel option");
          var sopt = $.map(options ,function(option) {
              if(svar == option.text){
                  return option.value;
              }            
          });
          $("#prodUP"+id + " .accVarSel").val(sopt).prop('selected', true);           
      });

      //WHEN ADDING ACCESORIES TO CART
      jQuery("#prodUP"+ id +" .atc").click(function(e){
          e.preventDefault();
          button = jQuery(this);
          button.html("Please wait");
          button.prop('disabled', true);
          pid = $("#prodUP"+id + " .accVarSel").val();
          shopifyAjaxAddURL   =            '/cart/add.js';
          parray = [];
          parray.push({
              variantId: pid,
              qty: 1
          });
          moveAlong = function() {
              if (parray.length) {
                  var request = parray.shift();
                  var data = 'id='+ request.variantId + '&quantity='+request.qty;
                  // Add to cart.
                  jQuery.ajax({
                      url: shopifyAjaxAddURL,
                      dataType: 'json',
                      type: 'post',
                      data: data,
                      success: function(itemData) {
                          moveAlong();
                      }, 
                      error: function(XMLHttpRequest) {
                          //_atcError(XMLHttpRequest);
                          alert("error");
                      }
                  });
              }else{
                  _updateCart();
              }
          };
          moveAlong();
          button.html("Adauga in Cos");
          button.prop('disabled', false);
          jQuery("#prodUP"+id).hide();
          jQuery("#upsell"+id).hide();
          hiddenEl = 0;
          nrElUps  = jQuery('#upsell-popup-adc .single-upsell').length;
          
          jQuery('#upsell-popup-adc .single-upsell').each(function(){
	        if ( $(this).css('display') == 'none'){
              hiddenEl++;
            }
      	  });

        jQuery(".hPCart").show();
        if(nrElUps == hiddenEl){
        	jQuery("#upsell-popup-adc").addClass('hide');
        }
      });
  });
    var _atcError = function(XMLHttpRequest){
        var $addToCartForm = jQuery("AddToCartForm");
        var $addToCartBtn = jQuery("#AddToCart");
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        if (response.slice(0,4) === 'All ') {
        _showFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
        $addToCartBtn.prop('disabled', false);
        _setText($addToCartBtn, _config.soldOutBtnLabel);
        $addToCartBtn.prop('disabled',true);
        }
        else {
            _showFeedback('error', '<i class="fa fa-warning"></i> ' + response, $addToCartForm);
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            _setText($addToCartBtn, _config.addToCartBtnLabel);
        }
    };
    var _checkMultiATC = function(){
        if( jQuery("#multiAtc").val() == "true"){
            return true;
        }else{
            return false;
        }
    }
    var _setText = function($button, label) {
        if ($button.children().length) {
            $button.children().each(function() {
                if ($.trim( jQuery(this).text()) !== '' ) {
                    jQuery(this).text(label);
                }
            });
        }
        else {
            $button.val(label).text(label);
        }
    };
    var _init = function() {   
        jQuery(document).ready(function() {
            jQuery(_config.addToCartFormSelector).submit(function(e) {
                e.preventDefault();
                //pinterest
              	if (typeof pintrk === "function") { 
					        pintrk('track', 'addtocart');
                }
                var $addToCartForm = jQuery(this);
                var $addToCartBtn = jQuery("#AddToCart")
                _setText($addToCartBtn, _config.addingToCartBtnLabel);
                $addToCartBtn.addClass('disabled').prop('disabled', true);
                //check if single or multiple
                if( _checkMultiATC() ){
                    parray = [];
                    console.log("PRODUCT:");
                    $mainProduct = JSON.parse( jQuery("#AddToCartForm [data-product-json]").html() );
                    console.log($mainProduct);
                    //get selected product
                    mainProdQty = jQuery("#Quantity").val();
                    mainProdid = jQuery("#productSelect").val();
                    //check handles exist
                    handlesNr = mainProdQty * jQuery("#handlesNr").val();
                    handlesId = jQuery("#handlesId").val();
                    //get feet
                    feetNr = mainProdQty * jQuery("#feetNr").val();
                    feetId = jQuery("#feetId").val();
                    //get fabric
                    fabricId = jQuery("#fabricId").val();
                    //CHECK IF OPTIONS EXIST
                    accentFinishId = jQuery("#accent_finishId").val();
                    customOptId = jQuery("#custom_optionId").val();
                    if(mainProdQty && mainProdid){
                        mainProProperties = {};
                        if(handlesNr && handlesId){
                          mainProProperties.Handles = handlesNr*mainProdQty + " x " + jQuery("#handleTxt").text();
                          mainProProperties._HandlesPrice =  mainProdQty * handlesNr * $("#handlesId").data("price");
                        }
                        if(accentFinishId){
                          mainProProperties.AccentFinish =  jQuery("#accentFinishTxt").text();
                          mainProProperties._AccentFinishPrice =  $("#accent_finishId").data("price");                          
                        }
                        if(customOptId){
                          mainProProperties.CustomOption =  jQuery("#customOptionTxt").text();
                        }
                        if(feetNr && feetId){
                          mainProProperties.Feet =  feetNr + " x " + jQuery("#feetTxt").text();
                        }
                        if(fabricId){
                          mainProProperties.Fabric =  jQuery("#fabricSTxt").text();
                        }
                      	console.log("mainProProperties");
                      	console.log(mainProProperties);
                        parray.push({
                            id: mainProdid,
                            quantity: mainProdQty,
                            properties: mainProProperties
                            /*
                            properties:{
                              "Handles": handlesNr + " x " + jQuery("#handleTxt").text()
                            }
                            */
                        });
                    }
                    //accent finish
                    if(accentFinishId){
                        parray.push({
                            id: accentFinishId,
                            quantity: mainProdQty,
                            properties:{
                              "_hide": true,
                              "_mainProduct": mainProdid,
                              "_type": "accent_finish",
                              "For": $mainProduct.title
                            }
                        });
                    }
                    //get custom option
                    if(customOptId){
                        parray.push({
                          id: customOptId,
                          quantity: mainProdQty,
                          properties:{
                            "_hide": true,
                            "_mainProduct": mainProdid,
                            "_type": "custom_option",
                            "For": $mainProduct.title
                          }
                        });
                    }
                    //get handles
                    if(handlesNr && handlesId){
                        parray.push({
                          id: handlesId,
                          quantity: handlesNr,
                          properties:{
                            "_hide": true,
                            "_mainProduct": mainProdid,
                            "_type": "handles",
                            "For": $mainProduct.title
                          }
                        });
                    }
                    //get feet
                    if(feetNr && feetId){
                        parray.push({
                            id: feetId,
                            quantity: feetNr,
                            properties:{
                              "_hide": true,
                              "_mainProduct": mainProdid,
                              "_type": "feet",
                              "For": $mainProduct.title
                            }
                        });
                    }
                    //get fabric
                    fabricId = jQuery("#fabricId").val();
                    if(fabricId){
                        parray.push({
                            id: fabricId,
                            quantity: mainProdQty,
                            properties:{
                              "_hide": true,
                              "_type": "fabric",
                              "_mainProduct": mainProdid,
                              "For": $mainProduct.title
                            }
                        });
                    }

                    Shopify.moveAlong = function() {
                        if (parray.length) {
                            var request = parray.shift();
                            var data = request;
                            /*var data = {
                              quantity:request.qty,
                              id:request.variantId,
                              properties: {
                              'Some prop': 'Some value'
                              }
                            }*/
                            // Add to cart.
                            jQuery.ajax({
                                url: _config.shopifyAjaxAddURL,
                                dataType: 'json',
                                type: 'post',
                                data: data,
                                success: function(itemData) {
                                    Shopify.moveAlong();
                                }, 
                                error: function(XMLHttpRequest) {
                                    _atcError(XMLHttpRequest);
                                }
                            });
                        }else{
                            _updateCart("1");
                        }
                    };
                    Shopify.moveAlong();
                }else{
                    // Add to cart.
                    /*mainProdQty = jQuery("#Quantity").val();
                    mainProdid = jQuery("#productSelect").val();
                    data = {
                      id: mainProdid,
                      quantity: mainProdQty,
                      properties: mainProProperties
                    }*/
                    jQuery.ajax({
                        url: _config.shopifyAjaxAddURL,
                        dataType: 'json',
                        type: 'post',
                        data: $addToCartForm.serialize(),
                        success: function(itemData) {
                            _updateCart(itemData);
                        }, 
                        error: function(XMLHttpRequest) {
                            _atcError(XMLHttpRequest);
                        }
                    });
                }

                return false;
            });
        });
    };
    return {
        init: function(params) {
            // Configuration
            params = params || {};
            // Merging with defaults.
            $.extend(_config, params);
            // Action
            jQuery(function() {
                _init();
            });
        },    
        getConfig: function() {
        return _config;
        }
    }  
    })(jQuery);
    Shopify.AjaxifyCart.init();
    $("#addAddress, #cancelAddAddress").click(function(e){
      e.preventDefault();
      jQuery("#add_address").toggle();
    });

    function compact(array) {
      var index = -1;
      var length = array == null ? 0 : array.length;
      var resIndex = 0;
      var result = [];

      while (++index < length) {
          var value = array[index];
          if (value) {
              result[resIndex++] = value;
          }
      }
      return result;
  }

  //PRODUCT ACCESSORIES
  function updateCart(){
      shopifyAjaxCartURL  =            '/cart.js'
      $.getJSON(shopifyAjaxCartURL, function(cart) {
          jQuery("#tCartNr, #PCartQty").html(cart.item_count);
          jQuery("#PCartTotal, #PCartTotal2").html( slate.Currency.formatMoney(cart.total_price, theme.moneyFormat) );
          if( cart.items.length){
              jQuery("#PCartProds").empty();
              for (var i = 0; i < cart.items.length; i++) {
                  var child = cart.items[i];
                  variantTxt = "";
                  if( child.variant_title != null ){
                      variantTxt = '<p>'+child.variant_title+'</p>';
                  }
                  jQuery("#PCartProds").append('<div class="gX cartLine cartLine'+child.id+'"><div class="s3 c"><img src="'+child.image+'" alt="'+child.product_title+'"></div><div class="s9 c"><div class="cartLC" data-id="'+child.id+'"><h5>'+child.product_title+'</h5>'+variantTxt+'<div class="cartLCqty">Quantity: '+child.quantity+'</div><span class="PcartRemove"><i class="i i-trash"></i></span><div class="cartLCprice">'+slate.Currency.formatMoney(child.final_line_price, theme.moneyFormat)+'</div></div></div></div>');
              }
          }
      });
      
  };
  
  jQuery('#accept_tc').change(function(){
    if(jQuery(this).is(':checked')){
      $("#tcError").hide();
    }
  });
  jQuery("#sideBChk").click(function(e){
    e.preventDefault();
    if (jQuery('#accept_tc').is(':checked')) {
      window.location.href = "/checkout";
    }else{
      //window.location.href = "/checkout";
      jQuery("#tcError").show();
    }
  });
  /* loading website chat */
  setTimeout(function () {
      var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
      (function(){
      var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
      s1.async=true;
      s1.src='https://embed.tawk.to/615b06bcd326717cb684a634/1fh5p4kmd';
      s1.charset='UTF-8';
      s1.setAttribute('crossorigin','*');
      s0.parentNode.insertBefore(s1,s0);
      })();
    }, 10000);
});

//PRODUCT CERERE POPUP
jQuery("#cereOferta").click(function(){
    jQuery("#progPopup").addClass('show');
});
jQuery(".popupClose").click(function(){
    jQuery("#progPopup").removeClass('show');
});


/* Sticky menu */

$(window).scroll(function(){
    if ($(window).scrollTop() >= 30) {
        $('#shopify-section-header').addClass('fixed');
    }
    else {
        $('#shopify-section-header').removeClass('fixed');
    }
});


jQuery( document ).ready(function($){  

  	/* View review */

  	function openReviewPopup(){
      	$('.open-review').on('click', function(){
          	$('#review-view .prodAccI').empty();
          	let urlRev = $(this).data('url');
          	console.log(urlRev);
          	$('#review-view').toggle();
			$.ajax({
               url:'https://rominafurniture.ro/blogs/' + urlRev,
               type:'GET',
               beforeSend: function() {
        			$('#review-view .prodAccI').html('<div class="loader">Se incarca recenzia</div>');
    		   },
    		   success: function(data) {
        			$('#review-view .prodAccI').empty();
                    $('#review-view .prodAccI').html($(data).find('#full-content-article').html());

    		   }
            });
        });
    };
  	openReviewPopup();
  
  	/* Dimension toggle */
  
    function dimensionToogle(){
      	$('.dimension').on('click', function(e){
        	let firstEl  = '.single-dimension.first',
            	heightEl = $(firstEl).height(),
            	heightI  = 0;
    		if($(this).hasClass('open')){
            	$(this).removeClass('open');
            }else{
                e.preventDefault();
        	    $(this).addClass('open');
            }
            $(this).children('.dimension-wrapper').children('.single-dimension').each(function(){
                if($('.dimension').hasClass('open')){
                    $(this).css("top", heightI);
                    heightI = heightI + heightEl + 4;
                }else{
                    $(this).css("top", "");
                }        
            });
        });
        //show active as first
      	jQuery("#AddToCartForm .dimension-wrapper .single-dimension.active").insertBefore("#AddToCartForm .dimension-wrapper .single-dimension.first");
       	jQuery("#AddToCartForm .dimension-wrapper .single-dimension.first").removeClass("first");
      	jQuery("#AddToCartForm .dimension-wrapper .single-dimension.active").addClass("first");
    };
  device = document.body.dataset.device;
  if(device == "mobile" || device == "tablet" || jQuery(window).width() < 1024){
    dimensionToogle();
  }
  //

});


function getRate(){

        var data = {};
      jQuery.ajax({
        type: 'GET',
        url: 'https://wholesale.rominafurniture.com/rate/rate.json',
        data: data,
        dataType: 'json',
        success: function(data) { 
          console.log(data);
        }
      });

}                           
getRate();
